import profileImage from "../image/profile.png";

/** プロフィールセクションの表示内容 */
export const profile = {
  image: profileImage,
  latinName: "Tatsumi Oikawa",
  kanjiName: "翁川 竜海",
  title: "Portfolios",
  bio: "Web・モバイルアプリを開発するソフトウェアエンジニアです。TypeScript / React / Flutter を中心に、幅広い開発に携わっています。",
};
